import { Component } from "react";
import PropTypes from "prop-types"
import Modal from "react-bootstrap/Modal"
import { toggleState } from 'shared/utilities'
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"

export default class CommentEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {showModal: true}
  }

  getValue() {
    return this.comment.value
  }

  _hideModal = () => {
    const {onBlur} = this.props

    onBlur(this.getValue())
    toggleState(this, 'showModal')
  }

  render(){
    const { value, onBlur, row, ...rest } = this.props
    return(
      <Modal show={this.state.showModal} onHide={() => this._hideModal()} size="lg" backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Add comment for {row.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Control
            { ...rest }
            as="textarea"
            ref={ node => this.comment = node }
            placeholder="Add Comment"
            value ={this.state.value}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={ () => onBlur(this.getValue()) }>Done</Button>
        </Modal.Footer>
      </Modal>
    )
  }
}

CommentEditor.defaultProps = {
  value: ""
}

CommentEditor.propTypes = {
  value: PropTypes.string,
  onBlur: PropTypes.func.isRequired,
  row: PropTypes.object.isRequired
}
